<base-support-modal [title]="title" [btnOkClass]="'btn-danger'" [btnOkLabel]="'Разблокировать'" (onOk)="ok()" >
	<p>Возобновить работу сайта: {{title}}?</p>
	<br>
	<p>Пользователь получит письмо о разблокировке на email: <strong>{{userEmail}}</strong></p>
</base-support-modal>
